import { Button } from '@magicschool/spellbook';
import { useStore } from 'features/store';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocale } from '@/hooks/useLocale';

export const LoginButtonClient = () => {
  const [pending, setPending] = useState(false);
  const { locale } = useLocale();
  const signinWithProvider = useStore(({ AuthStoreData: as }) => as.signinWithProvider, []);

  return (
    <Button
      onClick={() => {
        setPending(true);
        signinWithProvider('edlink', '/s/rooms', locale);
      }}
      disabled={pending}
      isLoading={pending}
      size="lg"
      fullWidth
    >
      <FormattedMessage id="auth.sign-in" />
    </Button>
  );
};
